namespace Matrix.Data {
    export interface TestRow {
        TestCode?: string;
        Description?: string;
        Enabled?: boolean;
        TestTypeCode?: string;
        Priority?: string;
        Script?: string;
        LastRunBatchId?: number;
        LastResultCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        LastRunBatchBatchDate?: string;
        LastRunBatchBatchCode?: string;
        LastRunBatchStartedBy?: string;
        LastRunBatchStartedWhen?: string;
        LastRunBatchFinishedWhen?: string;
        LastRunBatchDurationSeconds?: number;
        LastRunBatchSuccess?: boolean;
    }

    export namespace TestRow {
        export const idProperty = 'TestCode';
        export const nameProperty = 'TestCode';
        export const localTextPrefix = 'Data.Test';
        export const lookupKey = 'Data.Test';

        export function getLookup(): Q.Lookup<TestRow> {
            return Q.getLookup<TestRow>('Data.Test');
        }
        export const deletePermission = 'DataAdmin:Test';
        export const insertPermission = 'DataAdmin:Test';
        export const readPermission = 'Read:Test';
        export const updatePermission = 'DataAdmin:Test';

        export declare const enum Fields {
            TestCode = "TestCode",
            Description = "Description",
            Enabled = "Enabled",
            TestTypeCode = "TestTypeCode",
            Priority = "Priority",
            Script = "Script",
            LastRunBatchId = "LastRunBatchId",
            LastResultCode = "LastResultCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            LastRunBatchBatchDate = "LastRunBatchBatchDate",
            LastRunBatchBatchCode = "LastRunBatchBatchCode",
            LastRunBatchStartedBy = "LastRunBatchStartedBy",
            LastRunBatchStartedWhen = "LastRunBatchStartedWhen",
            LastRunBatchFinishedWhen = "LastRunBatchFinishedWhen",
            LastRunBatchDurationSeconds = "LastRunBatchDurationSeconds",
            LastRunBatchSuccess = "LastRunBatchSuccess"
        }
    }
}
